import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

const chartData = [
  { month: "Sep", interest: 120000, fees: 35000, penalties: 15000 },
  { month: "Oct", interest: 135000, fees: 38000, penalties: 18000 },
  { month: "Nov", interest: 150000, fees: 42000, penalties: 12000 },
  { month: "Dec", interest: 140000, fees: 40000, penalties: 20000 },
  { month: "Jan", interest: 160000, fees: 45000, penalties: 16000 },
  { month: "Feb", interest: 175000, fees: 48000, penalties: 14000 },
];

const tableData = [
  { branch: "Nairobi CBD", loans: 245, interest: "KES 520K", fees: "KES 85K", penalties: "KES 32K", total: "KES 637K" },
  { branch: "Westlands", loans: 180, interest: "KES 380K", fees: "KES 62K", penalties: "KES 24K", total: "KES 466K" },
  { branch: "Mombasa", loans: 156, interest: "KES 310K", fees: "KES 55K", penalties: "KES 19K", total: "KES 384K" },
  { branch: "Kisumu", loans: 120, interest: "KES 240K", fees: "KES 42K", penalties: "KES 15K", total: "KES 297K" },
  { branch: "Nakuru", loans: 98, interest: "KES 195K", fees: "KES 35K", penalties: "KES 12K", total: "KES 242K" },
];

export default function LoansRevenuePage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate("/reports")} className="p-2 rounded-lg hover:bg-accent transition-colors"><ArrowLeft className="h-5 w-5 text-foreground" /></button>
        <h1 className="text-2xl font-bold text-foreground">Loans Revenue</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
        {[{ title: "Total Interest", value: "KES 1.65M" }, { title: "Total Fees", value: "KES 248K" }, { title: "Total Penalties", value: "KES 95K" }, { title: "Grand Total", value: "KES 2.03M" }].map(s => (
          <Card key={s.title}><CardContent className="p-5"><p className="text-sm text-muted-foreground">{s.title}</p><p className="text-2xl font-bold mt-1">{s.value}</p></CardContent></Card>
        ))}
      </div>
      <Card>
        <CardHeader><CardTitle>Revenue Trend</CardTitle></CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
              <XAxis dataKey="month" className="text-muted-foreground" />
              <YAxis className="text-muted-foreground" />
              <Tooltip contentStyle={{ backgroundColor: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: "8px", color: "hsl(var(--foreground))" }} />
              <Bar dataKey="interest" name="Interest" fill="hsl(var(--primary))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="fees" name="Fees" fill="hsl(142 70% 50%)" radius={[4, 4, 0, 0]} />
              <Bar dataKey="penalties" name="Penalties" fill="hsl(0 80% 60%)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>Revenue by Branch</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader><TableRow>
              <TableHead>Branch</TableHead><TableHead>Active Loans</TableHead><TableHead>Interest</TableHead><TableHead>Fees</TableHead><TableHead>Penalties</TableHead><TableHead>Total Revenue</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {tableData.map(r => (
                <TableRow key={r.branch}>
                  <TableCell className="font-medium">{r.branch}</TableCell><TableCell>{r.loans}</TableCell><TableCell>{r.interest}</TableCell><TableCell>{r.fees}</TableCell><TableCell>{r.penalties}</TableCell><TableCell className="font-bold">{r.total}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
